import { render, staticRenderFns } from "./books_manage_import.vue?vue&type=template&id=cc70799c&"
import script from "./books_manage_import.vue?vue&type=script&lang=js&"
export * from "./books_manage_import.vue?vue&type=script&lang=js&"
import style0 from "./books_manage_import.vue?vue&type=style&index=0&id=cc70799c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports